<div class="form-step-instructions" [formGroup]="form">
	@if (variant === 'editable' && showSectionHeader) {
		<div class="item-group">
			<span class="form-step-section-header">{{
				'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.INSTRUCTIONS_SECTION' | translate
			}}</span>
		</div>
	}

	<tec-tabs [tabs]="stepLocaleTabs" (tabSelected)="onStepLocaleTabSelected($event)" />

	<div id="form-step-locale-field-guideline" class="form-step-locale-field">
		<tec-form-group
			[label]="('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.GUIDELINE' | translate) + '*'"
			[description]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.GUIDELINE_DESCRIPTION' | translate"
			[errorMsg]="localeFieldErrorMessage('step_name')"
		>
			<tec-input
				[formControl]="getLocaleFormControl('step_name', selectedStepLocaleId)"
				[placeholder]="
					variant === 'editable'
						? ('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.GUIDELINE_PLACEHOLDER' | translate)
						: ''
				"
				[hasError]="localeFieldHasError('step_name')"
			></tec-input>
		</tec-form-group>
	</div>

	<div id="form-step-locale-field-description" class="form-step-locale-field">
		<tec-form-group
			[label]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.STEP_DESCRIPTION' | translate"
			[description]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.STEP_DESCRIPTION_HINT' | translate"
			[errorMsg]="localeFieldErrorMessage('step_description')"
		>
			<tec-input
				[formControl]="getLocaleFormControl('step_description', selectedStepLocaleId)"
				[placeholder]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.STEP_DESCRIPTION_PLACEHOLDER' | translate"
				[hasError]="localeFieldHasError('step_description')"
			/>
		</tec-form-group>
	</div>
</div>
